export const buildFanficCatalogFallbackHref = (filters: {
  fandoms?: string;
  characters?: string;
  tags?: string;
}): string => {
  const search = new URLSearchParams();
  if (filters.fandoms) search.set('fandoms', filters.fandoms);
  if (filters.characters) search.set('characters', filters.characters);
  if (filters.tags) search.set('tags', filters.tags);
  const query = search.toString();
  return query ? `/fanfics?${query}` : '/fanfics';
};

export const buildOriginalsCatalogFallbackHref = (filters: { tags?: string }): string => {
  const search = new URLSearchParams();
  if (filters.tags) search.set('tags', filters.tags);
  const query = search.toString();
  return query ? `/originals?${query}` : '/originals';
};
